import { isNativeApp } from './platform.js';

const OPT_IN_KEY = 'rk-edition-alerts';
const LAST_SEEN_KEY = 'rk-edition-last-seen';
const LAST_ALERT_KEY = 'rk-edition-last-alert';

export function getEditionAlertsEnabled() {
  try {
    return localStorage.getItem(OPT_IN_KEY) === '1';
  } catch {
    return false;
  }
}

export function setEditionAlertsEnabled(on) {
  try {
    localStorage.setItem(OPT_IN_KEY, on ? '1' : '0');
  } catch {
    /* ignore */
  }
}

export function getLastSeenEdition() {
  try {
    return localStorage.getItem(LAST_SEEN_KEY) || '';
  } catch {
    return '';
  }
}

export function markEditionSeen(dateKey) {
  if (!dateKey) return;
  try {
    localStorage.setItem(LAST_SEEN_KEY, dateKey);
  } catch {
    /* ignore */
  }
}

function getLastAlerted() {
  try {
    return localStorage.getItem(LAST_ALERT_KEY) || '';
  } catch {
    return '';
  }
}

function markAlerted(dateKey) {
  try {
    localStorage.setItem(LAST_ALERT_KEY, dateKey);
  } catch {
    /* ignore */
  }
}

/**
 * Local fallback when the app is open (Web Notification API).
 * Real closed-app alerts use APNs via pushNotifications.js.
 */
export async function maybeAlertNewEdition({ dateKey, title, body }) {
  if (!isNativeApp() || !dateKey || !getEditionAlertsEnabled()) return false;
  if (getLastAlerted() === dateKey) return false;
  if (typeof Notification === 'undefined') return false;

  try {
    let perm = Notification.permission;
    if (perm === 'default') {
      perm = await Notification.requestPermission();
    }
    if (perm !== 'granted') return false;

    new Notification(title || 'Repatikosam', {
      body: body || 'Today’s e-paper is ready',
      tag: `edition-${dateKey}`,
      icon: '/rk-logo.webp',
    });
    markAlerted(dateKey);
    return true;
  } catch {
    return false;
  }
}

export async function enableEditionAlerts(authToken) {
  setEditionAlertsEnabled(true);
  if (!isNativeApp()) {
    if (typeof Notification === 'undefined') return false;
    try {
      const perm = await Notification.requestPermission();
      return perm === 'granted';
    } catch {
      return false;
    }
  }
  try {
    const { initPushNotifications } = await import('./pushNotifications.js');
    return await initPushNotifications(authToken);
  } catch {
    return false;
  }
}

export async function disableEditionAlerts() {
  setEditionAlertsEnabled(false);
  if (!isNativeApp()) return;
  try {
    const { unregisterPushNotifications } = await import('./pushNotifications.js');
    await unregisterPushNotifications();
  } catch {
    /* ignore */
  }
}
